import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const TEXT_COLOR_TYPE = 'wix-rich-content-text-color';
export const TEXT_HIGHLIGHT_TYPE = 'wix-rich-content-text-highlight';

export interface TextColorPluginEditorConfig extends EditorPluginConfig, PluginEditorConfigCommon {
  inlinePopups?: boolean;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export interface TextColorPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface TextHighlightPluginEditorConfig
  extends EditorPluginConfig,
    PluginEditorConfigCommon {
  inlinePopups?: boolean;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export interface TextHighlightPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

type PluginEditorConfigCommon = {
  colorScheme?: Record<string, { color: string; index: number }>;
  /* TODO: make it required in next major version */
  onColorAdded?: (color: string) => string[];
  getUserColors?: () => string[];
};
